import { gql } from '@apollo/client'

export const UPDATE_SUBSCRIPTION_PLAN = gql`
  mutation UpdateSubscriptionPlan($input: UpdateSubscriptionPlanInput!) {
    updateSubscriptionPlan(input: $input) {
      success
      subscriptionId
      quantity
    }
  }
`
